/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import type { CharityBalancePaymentDto } from '../models/CharityBalancePaymentDto';
import type { CharityBalancePaymentResponseDto } from '../models/CharityBalancePaymentResponseDto';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
@Injectable({
    providedIn: 'root',
})
export class SuperAdminCharityPaymentsService {
    constructor(public readonly http: HttpClient) {}
    /**
     * Process charity balance payment to solicitor for will request
     * Super admin endpoint to record payment from charity account balance to solicitor for will preparation services
     * @param idempotencyKey Unique key to prevent duplicate payments (UUID recommended)
     * @param requestBody Data for processing charity balance payment
     * @returns CharityBalancePaymentResponseDto The charity balance payment has been successfully processed.
     * @throws ApiError
     */
    public superAdminCharityPaymentsControllerProcessCharityBalancePayment(
        idempotencyKey: string,
        requestBody: CharityBalancePaymentDto,
    ): Observable<Array<CharityBalancePaymentResponseDto>> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/super-admin/charity-payments/process-payment',
            headers: {
                'Idempotency-Key': idempotencyKey,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid input data, insufficient balance, or missing Idempotency-Key header.`,
                403: `Access denied. Super admin role required.`,
                404: `Will request, charity, or solicitor not found.`,
                409: `Request with this idempotency key is already being processed.`,
            },
        });
    }
    /**
     * Get charity balance payment by ID
     * @param id The UUID of the charity balance payment
     * @returns CharityBalancePaymentResponseDto The charity balance payment details.
     * @throws ApiError
     */
    public superAdminCharityPaymentsControllerGetCharityBalancePaymentById(
        id: string,
    ): Observable<CharityBalancePaymentResponseDto> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/super-admin/charity-payments/payment/{id}',
            path: {
                'id': id,
            },
            errors: {
                403: `Access denied. Super admin role required.`,
                404: `Payment not found.`,
            },
        });
    }
    /**
     * Get all charity balance payments for a specific charity
     * @param charityId The UUID of the charity
     * @returns CharityBalancePaymentResponseDto List of charity balance payments for the specified charity.
     * @throws ApiError
     */
    public superAdminCharityPaymentsControllerGetCharityBalancePaymentsByCharityId(
        charityId: string,
    ): Observable<Array<CharityBalancePaymentResponseDto>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/super-admin/charity-payments/charity/{charityId}/payments',
            path: {
                'charityId': charityId,
            },
            errors: {
                403: `Access denied. Super admin role required.`,
            },
        });
    }
    /**
     * Get all charity balance payments for a specific solicitor
     * @param solicitorId The UUID of the solicitor
     * @returns CharityBalancePaymentResponseDto List of charity balance payments for the specified solicitor.
     * @throws ApiError
     */
    public superAdminCharityPaymentsControllerGetCharityBalancePaymentsBySolicitorId(
        solicitorId: string,
    ): Observable<Array<CharityBalancePaymentResponseDto>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/super-admin/charity-payments/solicitor/{solicitorId}/payments',
            path: {
                'solicitorId': solicitorId,
            },
            errors: {
                403: `Access denied. Super admin role required.`,
            },
        });
    }
    /**
     * Get all charity balance payments for a specific will request
     * @param willRequestId The UUID of the will request
     * @returns CharityBalancePaymentResponseDto List of charity balance payments for the specified will request.
     * @throws ApiError
     */
    public superAdminCharityPaymentsControllerGetCharityBalancePaymentsByWillRequestId(
        willRequestId: string,
    ): Observable<Array<CharityBalancePaymentResponseDto>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/super-admin/charity-payments/will-request/{willRequestId}/payments',
            path: {
                'willRequestId': willRequestId,
            },
            errors: {
                403: `Access denied. Super admin role required.`,
            },
        });
    }
}
